import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './style.scss';
import Logo from '../Logo';

const NavigationBar = ({ userName, userGroup, navItems, logoutHandler }) => {
	return (
		<header className="header">
			<nav className="nav">
				<NavLink to="/" className="nav-item-logo">
					<Logo className="logo" />
				</NavLink>
				{userGroup &&
					navItems.map((item, index) => (
						<NavLink to={`/${item.link}`} className="nav-item" activeClassName="active" key={index}>
							{item.name}
						</NavLink>
					))}
			</nav>
			<div className="user-info">
				<p className="username-label">{userName}</p>
				<button title="Logout" onClick={() => logoutHandler()} className="material-icons logout-button">
					logout
				</button>
			</div>
		</header>
	);
};

NavigationBar.propTypes = {
	userName: PropTypes.string,
	userGroup: PropTypes.array,
	navItems: PropTypes.array,
	logoutHandler: PropTypes.func
};

export default NavigationBar;
